<template>
  <article class="message is-danger create-game">
    <div class="message-header">
      <p>Quick Pairing</p>
    </div>
    <div class="message-body">
      <div class="quick-match-buttons">
        <b-tooltip
          v-for="qm in quickMatches"
          :key="qm.duration * 1000 + qm.increment"
          :label="getTimeControlDescription(qm)"
          position="is-top"
          size="is-small"
          :type="getButtonClass(qm.duration)"
          multilined
          :append-to-body="true"
          class="tooltip-wrapper"
        >
          <button
            :disabled="currentMatch"
            class="button time-control-button"
            :class="getButtonClass(qm.duration)"
            @click="createMatch(qm.duration * 60, qm.increment)"
          >
            <span class="time-display">{{ qm.duration }}</span>
            <span class="increment-display">+{{ qm.increment }}</span>
          </button>
        </b-tooltip>
      </div>

      <div
        v-if="currentMatch && !currentMatch.startedAt && waitingTime"
        class="waiting-section"
      >
        <button class="button is-static px-2">
          <span>Waiting for an opponent |&nbsp;</span>
          <TimerDisplay :duration="300 - Math.floor(waitingTime)" :run="true" />
        </button>
        <button
          class="button is-danger cancel-button"
          :disabled="waitingTime < 5"
          @click="cancelMatch"
        >
          <b-icon icon="times"></b-icon>
        </button>
      </div>
    </div>
  </article>
</template>
<script>
import TimerDisplay from "@/components/TimerDisplay.vue";
import { MATCH_DEFAULT, QUICK_MATCHES } from "../../constants";

export default {
  name: "CreateGame",

  components: {
    TimerDisplay,
  },

  props: ["currentMatch", "waitingTime"],

  data() {
    return {
      durationInMinutes: MATCH_DEFAULT.DURATION / 60,
      variant: MATCH_DEFAULT.VARIANT,
      quickMatches: QUICK_MATCHES,
    };
  },

  computed: {
    duration() {
      return this.durationInMinutes * 60;
    },
  },

  methods: {
    createMatch(duration, increment, variant) {
      this.$emit("onCreateMatch", duration, increment, variant);
    },

    cancelMatch() {
      if (!this.currentMatch) return;
      this.$emit("onCancelMatch", this.currentMatch);
    },

    getButtonClass(duration) {
      if (duration <= 2) return "is-info"; // Blitz
      if (duration <= 5) return "is-success"; // Short Rapid
      if (duration <= 15) return "is-danger"; // Rapid
      return "is-primary"; // Classical
    },

    getTimeControlDescription(qm) {
      let type = "classical";
      if (qm.duration <= 2) type = "bullet";
      else if (qm.duration <= 5) type = "blitz";
      else if (qm.duration <= 15) type = "rapid";

      return `${qm.duration} min \n+ ${qm.increment}s increment\n${[type]}`;
    },
  },

  watch: {
    currentMatch: function (currentMatch) {
      if (currentMatch && currentMatch.duration) {
        this.durationInMinutes = Math.floor(currentMatch.duration / 60);
      }
    },
  },
};
</script>

<style scoped>
.message-header p {
  margin: auto;
}

.message-body {
  padding: 1rem;
}

.quick-match-buttons {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));
  gap: 0.75rem;
}

.time-control-button {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  transition: transform 0.2s ease;
  font-weight: 600;
  border: none;
}

.time-control-button:not(:disabled):hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.time-control-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.time-display {
  font-size: 1.2em;
  line-height: 1.2;
}

.increment-display {
  font-size: 0.9em;
  opacity: 0.9;
}

.waiting-section {
  display: flex;
  gap: 0.75rem;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
}

.cancel-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
</style>
